import { toast } from 'react-toastify';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { getTranslation } from '../../utils/get-translation.util';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { DATA_ROOM_ACCESS_INVALIDATION_KEYS } from './access-invalidation.const';
import { DataRoomAccessRow, ShareRecipient } from './space.types';

type ShareVariables = { id: string; message?: string; recipients: ShareRecipient[] };

export const useShareDataRoom = () => {
  const { invalidateQuery } = useInvalidateQueries(...DATA_ROOM_ACCESS_INVALIDATION_KEYS);

  const { isPending, mutate: shareDataRoom } = useAppMutation<
    DataRoomAccessRow[],
    unknown,
    ShareVariables
  >([QueryKey.DATA_ROOM_SHARE], {
    mutationFn: ({ id, ...body }) =>
      ApiService.post({ endpoint: BackendRoute.DATA_ROOMS, routePath: [id, 'access'] }, { body }),
    onSuccess: (_rows, { recipients }) => {
      invalidateQuery();
      toast.success(
        recipients.length === 1
          ? getTranslation('INVITATION_SHARED_SUCCESSFULLY')
          : getTranslation('INVITATIONS_SHARED_SUCCESSFULLY', { count: recipients.length }),
      );
    },
  });

  return { isPending, shareDataRoom };
};
